import {RunConfigService, init} from '@nuskin/ns-util';
import appStage, {clientId} from '../config/appStage.js';

console.debug('Loading Run Config from AEM env', appStage.aem);

let runConfig = RunConfigService.getRunConfig();

if (!runConfig.baseUrl) {
    init(runConfig);
    runConfig = RunConfigService.getRunConfig();
}

if (!runConfig.country && !runConfig.language) {
    // Try and grab the locale parts from the URL path
    const match = window.location.pathname.match(/^\/static\/signup\/([a-z]{2})_([A-Z]{2})/);
    let country = 'US';
    let language = 'en';
    if (match) {
        language = match[1];
        country = match[2];
    }
    console.debug('Updating RunConfig locale from URL', {country, language});
    // If we don't clear out the siteConfigurationPath, we can end up loading the wrong region's settings.
    RunConfigService.addRunConfig({
        country,
        language,
        siteConfigurationPath: undefined,
        client_id: clientId
    });
} else {
    RunConfigService.addRunConfig({
        clientId: clientId
    });
}
